/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Link, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import ToastComponent from "./components/toastComponent/toastComponent";
import {
  authProtectedRoutes,
  publicRoutes,
  mangerProtectedRoutes,
} from "./routes/";
import VerticalLayout from "./components/verticalLayout/index";
import Loading from "./components/loading/loading";
import { useNavigate } from "react-router-dom";
import Constant from "../src/util/constant";

// import "./assets/scss/theme.scss";
import "./app.scss";

/**
 *
 *
 * The main component of the application.
 * @param {Object} props - The props passed to the component.
 * @returns The rendered JSX elements.
 */
function App(props) {
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  // const stateRole = useSelector(state => state.roleCheck.loginrole)
  const stateRole = window.localStorage.getItem(
    Constant.LOCALSTORAGEKEYS.LOGINROLE
  );

  useEffect(() => {
    const clarityId = process.env.REACT_APP_MS_CLARITY_ID;
    console.log('clarityId', clarityId)
    if (!clarityId) return;

    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", clarityId);
  }, []);

  /**
   * useEffect hook that checks if the user is authenticated and redirects them to the
   * usersManagement page if they are.
   * @returns None
   */
  useEffect(() => {
    if (!window.localStorage.getItem(Constant.LOCALSTORAGEKEYS.ACCESSTOKEN)) {
      navigate("/");
    }

    if (
      localStorage.getItem(Constant.LOCALSTORAGEKEYS.AUTHUSER) !== undefined &&
      localStorage.getItem(Constant.LOCALSTORAGEKEYS.AUTHUSER) === true
    ) {
      return <Link to={{ pathname: "/usersManagement" }} />;
    }
  }, []);

  return (
    /**
     * Renders a React component that includes a toast component, a loading component, and a set of routes.
     * The routes are conditionally rendered based on the user's role.
     * @returns {React.Fragment} - The rendered React component.
     */
    <React.Fragment>
      <ToastComponent />
      <Loading show={state.LoaderReducer.loader.show} />
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} exact />
        ))}

        {stateRole === "Admin" ? (
          <>
            {authProtectedRoutes.map((route, idx) => (
              <Route key={idx} element={<VerticalLayout />}>
                <Route path={route.path} element={route.element} exact />
              </Route>
            ))}
          </>
        ) : (
          <>
            {mangerProtectedRoutes.map((route, idx) => (
              <Route key={idx} element={<VerticalLayout />}>
                <Route path={route.path} element={route.element} exact />
              </Route>
            ))}
          </>
        )}
      </Routes>
    </React.Fragment>
  );
}
export default App;
